import React from 'react'

import MessageItem from './MessageItem'

// Normalize a createdAt value (Firestore Timestamp or JS Date) to milliseconds
// so messages can be compared consistently for chronological ordering.
const toMillis = (createdAt) => {
  const date = createdAt?.toDate ? createdAt.toDate() : createdAt
  const time = date instanceof Date ? date.getTime() : NaN
  return isNaN(time) ? 0 : time
}

// Render a ticket's message thread ordered by createdAt ascending (Req 4.5).
// Sorts a copy of the messages so the prop is never mutated.
const MessageList = ({ messages = [] }) => {
  if (messages.length === 0) {
    return <p className='p-3 m-2 text-sm text-gray-500'>No messages yet</p>
  }

  const ordered = [...messages].sort(
    (a, b) => toMillis(a.createdAt) - toMillis(b.createdAt)
  )

  return (
    <div>
      {ordered.map((message) => (
        <MessageItem key={message.id} message={message} />
      ))}
    </div>
  )
}

export default MessageList
